import { render } from "./PermissionSelector.vue?vue&type=template&id=8af77528&scoped=true"
import script from "./PermissionSelector.vue?vue&type=script&lang=js"
export * from "./PermissionSelector.vue?vue&type=script&lang=js"

import "./PermissionSelector.vue?vue&type=style&index=0&id=8af77528&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af77528"]])

export default __exports__